import moment from 'moment';

export const daysDiff = (endDate, startDate) => {
    let difference
    difference = moment(new Date(endDate)).diff(moment(new Date(startDate)), 'day')

    return difference+1
}